module.exports = __webpack_public_path__ + "img/DE02711.785d5c6e.png";